var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8182 22.0909H20.0909C20.8624 22.0909 21.6024 21.7843 22.1479 21.2388C22.6935 20.6932 23 19.9534 23 19.1818V11.9091C23 11.1376 22.6935 10.3976 22.1479 9.85201C21.6024 9.30645 20.8624 9 20.0909 9H11.3636C10.5921 9 9.85215 9.30645 9.30659 9.85201C8.76103 10.3976 8.45454 11.1376 8.45454 11.9091V15.5454M7 19.9091H14.2727M7 17.7273H9.90909M22.4176 10.4763C18.3376 18.2145 13.1013 18.2072 9.0213 10.4763",
    stroke: "#F59B48",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgEmail);
export default __webpack_public_path__ + "static/media/svg_email.376deba9a923930b8d1db79a6d2f15be.svg";
export { ForwardRef as ReactComponent };